module.exports = __webpack_public_path__ + "static/media/menu.fd237185.svg";